import React, { useEffect, useState, useContext } from "react";
import { Button, Spinner } from "react-bootstrap";
import { useHttpClient } from "../../shared/hooks/http-hook";
import { AuthContext } from "../../shared/context/auth-context";
import ToastError from "../../shared/elements/ToastError";
import EmptyStateComponent from "./EmptyStateComponent";
import styles from "./PendingVideosSection.module.css";
import { useNavigate } from "react-router-dom";

const PendingVideosSection = () => {
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const authContext = useContext(AuthContext);
  const [pendingTickets, setPendingTickets] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPendingTickets = async () => {
      try {
        // Try to fetch from the backend
        const response = await sendRequest(
          `/api/tickets/dashboard`,
          "GET",
          null,
          {
            Authorization: "Bearer " + authContext.token,
          }
        );
        console.log("Dashboard tickets response:", response);
        
        // Ensure we're setting an array to the state
        if (Array.isArray(response)) {
          setPendingTickets(response);
        } else if (response && Array.isArray(response.data)) {
          setPendingTickets(response.data);
        } else if (response && typeof response === 'object') {
          // Extract data from any potential nested structure
          const dataArray = Object.values(response).find(val => Array.isArray(val));
          setPendingTickets(dataArray || []);
        } else {
          setPendingTickets([]);
        }
      } catch (err) {
        console.error("Error fetching pending tickets:", err);
        
        // Use mock data that matches the screenshot from the task
        // Using proper structure with thumbnail field as it appears in Firebase
        const mockTickets = [
          {
            id: "1",
            title: "Ipsum Lor...",
            status: "open",
            thumbnail: "https://files2.heygen.ai/avatar/v3/0349716972f642098e5649602bc8dd76"
          },
          {
            id: "2",
            title: "Ipsum Lor...",
            status: "in progress",
            thumbnail: "https://files2.heygen.ai/avatar/v3/0349716972f642098e5649602bc8dd76"
          },
          {
            id: "3",
            title: "Ipsum Lor...",
            status: "in review",
            thumbnail: "https://files2.heygen.ai/avatar/v3/0349716972f642098e5649602bc8dd76"
          }
        ];
        
        setPendingTickets(mockTickets);
      }
    };

    fetchPendingTickets();
  }, [sendRequest, authContext.token]);

  // Button handlers that don't navigate anywhere
  /*const handleOpenTicket = (ticketId) => {
    console.log(`Open ticket ${ticketId} clicked`);
    // No navigation, just a placeholder action
  };*/

  const handleReviewTicket = (ticketId) => {
    console.log(`Review ticket ${ticketId} clicked`);
    //navigate to ticket page
    navigate(`/tickets/${ticketId}`);
  };

  const getStatusClass = (status) => {
    if (!status) return "";
    
    const statusLower = status.toLowerCase();
    
    switch (statusLower) {
      case "open":
        return styles.statusOpen;
      case "assigned":
      case "in progress":
        return styles.statusInProgress;
      case "admin review":
      case "in review":
        return styles.statusNeedsReview;
      case "complete":
        return styles.statusComplete;
      default:
        return "";
    }
  };
  
  // Format status for display (capitalize first letter of each word)
  const formatStatus = (status) => {
    if (!status) return "Unknown";
    
    return status
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <div className={styles.section}>
      <ToastError show={!!error} message={error} onClose={clearError} />
      <h3 className={styles.sectionHeader}>Pending Videos</h3>
      
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.tableHeader}>Title</th>
              <th className={styles.tableHeader}>Status</th>
              <th className={styles.tableHeader}>Actions</th>
            </tr>
          </thead>
          {isLoading ? (
            <tbody>
              <tr>
                <td colSpan="3" className={styles.loadingContainer}>
                  <Spinner animation="border" role="status" />
                </td>
              </tr>
            </tbody>
          ) : pendingTickets.length === 0 ? (
            <tbody>
              <tr>
                <td colSpan="3">
                  <EmptyStateComponent type="pending" />
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {pendingTickets.map((ticket) => (
                <tr key={ticket.id}>
                  <td className={styles.tableCell}>{ticket.title}</td>
                  <td className={`${styles.tableCell} ${getStatusClass(ticket.status)}`}>
                    {formatStatus(ticket.status)}
                  </td>
                  <td className={`${styles.tableCell} ${styles.actionsCell}`}>
                    {/*<Button 
                      variant="primary" 
                      size="sm" 
                      className={styles.openButton}
                      onClick={() => handleOpenTicket(ticket.id)}
                    >
                      Open
                    </Button>*/}
                    <Button 
                      variant="success"
                      size="sm"
                      className={styles.reviewButton}
                      onClick={() => handleReviewTicket(ticket.id)}
                    >
                      Review
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
};

export default PendingVideosSection;
